import { useEffect, useState } from "react";
import { getCookieConsentValue } from "react-cookie-consent";

export const COOKIE_CONSENT_KEY = "CookieConsent";

const useCookieConsent = () => {
  const isCookiesConsent = getCookieConsentValue(COOKIE_CONSENT_KEY);
  const [cookieConsent, setCookieConsent] = useState(!!isCookiesConsent);

  useEffect(() => {
    if (isCookiesConsent) {
      setCookieConsent(true);
    } else {
      setCookieConsent(false);
    }
  }, [isCookiesConsent]);

  const handleAcceptConsent = () => {
    setCookieConsent(true);
  };

  return { cookieConsent, handleAcceptConsent };
};

export default useCookieConsent;
